import React from 'react';
import { css } from '@linaria/core';
import { brand, findColorFromCSSVariable, theme } from '@terveystalo/design-system-theme';
import { classnames } from '../../utils';
import { Text } from '../../atoms/Typography';
import { calcPadding3_5 } from '../../css-utils/calculation';
import { Icon } from '../../atoms';
const labelStyles = css `
  border-radius: ${brand.formControl.border.radius};
  display: flex;
  flex-direction: row;
  padding: ${calcPadding3_5(theme.typography.lineHeight.body.m, '1')};

  /* Remove tap highlight in mobile context for some browsers */
  -webkit-tap-highlight-color: transparent;

  > input {
    margin-right: ${theme.spacing['1']};
    flex-shrink: 0;
    cursor: inherit;
  }
`;
const labelHoverStyles = css `
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 0 ${theme.border.width.xxs} ${brand.formControl.color.hover.outline};
  }
  &:active {
    box-shadow: 0 0 0 ${theme.border.width.xs} ${brand.formControl.color.active.outline};
  }
`;
const reducedLabelHoverStyles = css `
  cursor: pointer;
`;
const labelInvalidStyles = css `
  box-shadow: 0 0 0 ${theme.border.width.xs} ${brand.formControl.color.invalid.outline};
`;
const labelWarningStyles = css `
  box-shadow: 0 0 0 ${theme.border.width.xs} ${brand.formControl.color.warning.border};
`;
const contentStyles = css `
  flex-grow: 1;
  display: flex;
  border-radius: ${brand.formControl.border.radius};
`;
const iconStyles = css `
  margin-right: ${theme.spacing['1']};
`;
const determineTextColor = (disabled, contentStyle) => {
    if (disabled) {
        return findColorFromCSSVariable(brand.formControl.color.disabled.content);
    }
    if (contentStyle === 'error') {
        return findColorFromCSSVariable(brand.formControl.color.error.content);
    }
    if (contentStyle === 'warning') {
        return findColorFromCSSVariable(brand.formControl.color.warning.content);
    }
    return findColorFromCSSVariable(brand.formControl.color.default.content);
};
export const FormControlWrapper = (props) => {
    const { label, inputControl, children, className, disabled, expanded, grayBackground, required, invalid, reduced, contentStyle, icon, } = props;
    const computedTextColor = determineTextColor(disabled, contentStyle);
    return (React.createElement("div", { className: classnames(!reduced &&
            css `
            background-color: ${brand.formControl.color.default.background.onLight};
            border-radius: ${brand.formControl.border.radius};
            margin-bottom: ${theme.spacing['0_5']};
          `, !reduced &&
            !disabled &&
            css `
            box-shadow: inset -1px -1px 0px ${brand.formControl.color.default.border};
          `, grayBackground &&
            css `
            background-color: ${brand.formControl.color.default.background.onDark};
          `, contentStyle === 'warning' &&
            css `
            background-color: ${brand.formControl.color.warning.background};
          `, contentStyle === 'error' &&
            css `
            background-color: ${brand.formControl.color.error.background};
          `, className) },
        React.createElement("label", { className: classnames(labelStyles, reduced && !disabled && !invalid && reducedLabelHoverStyles, !reduced && !disabled && !invalid && labelHoverStyles, invalid && labelInvalidStyles, contentStyle === 'warning' && !invalid && labelWarningStyles, contentStyle === 'warning' && invalid && labelInvalidStyles, contentStyle === 'error' && labelInvalidStyles) }, icon ? (React.createElement(React.Fragment, null,
            React.createElement(Icon, { name: icon, className: iconStyles }),
            React.createElement(Text, { size: "m", color: computedTextColor, className: contentStyles },
                label,
                required && (React.createElement(Text, { size: "m", color: findColorFromCSSVariable(brand.formControl.color.invalid.content), "aria-hidden": "true", className: css `
                    margin-left: 0.125rem;
                  ` }, "*"))),
            inputControl)) : (React.createElement(React.Fragment, null,
            inputControl,
            React.createElement(Text, { size: "m", color: computedTextColor, className: contentStyles },
                label,
                required && (React.createElement(Text, { size: "m", color: findColorFromCSSVariable(brand.formControl.color.invalid.content), "aria-hidden": "true", className: css `
                    margin-left: 0.125rem;
                  ` }, "*")))))),
        expanded && Boolean(children) && (React.createElement("div", { className: css `
            padding: ${theme.spacing['1']} ${theme.spacing['1']} ${theme.spacing['2']};
          ` }, children))));
};


import "../../../css/molecules/FormControlItem/FormControlWrapper.css";
